import SettingsRow from './SettingsRow';
import { SettingsRowProps, SettingsRowValueProps, SettingsRowCombinedProps } from './types'; // MANUAL OVERRIDE

export type { SettingsRowProps, SettingsRowValueProps, SettingsRowCombinedProps };
export default SettingsRow;
